// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetGeoTagsRequest,
  TGetGeoTagsModel,
  IMappers,
  TGetGeoTagsResponse,
  TGetGeoTagsResponse_1,
  TGetGeoTagsResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGetGeoTagsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'geo-temp-layer',
  pathApi: '/v1/get-geo-tags/',
  requestContentType: 'json',
  interserviceAuthEnabled: true,
} as TGetGeoTagsModel;

export function createGetGeoTagsModel(parameters: TGetGeoTagsRequest): TGetGeoTagsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetGeoTagsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetGeoTagsRequest;
}

export async function fetchGetGeoTags<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetGeoTagsOptions<TResponse200, TResponse400>): Promise<TGetGeoTagsResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetGeoTagsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetGeoTagsResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetGeoTagsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetGeoTagsResponse;
}
